import React from "react";
import { Button } from "../../ui-library/Button/Button.tsx";
import styles from "./RegenerateSummaryButton.module.css";
export const RegenerateSummaryButton: React.FC<{
  onClick: () => void;
  disabled?: boolean;
}> = (props) => (
  <Button
    variant={"transparent"}
    className={styles.RegenerateSummaryButton}
    onClick={props.onClick}
    disabled={props.disabled}
  >
    <SparkleIcon />
    Regenerate Summary
  </Button>
);

const SparkleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9.93161 6.59826C10.3522 5.27954 12.0527 5.2396 12.5513 6.47844L12.5935 6.59901L13.1611 8.37741C13.2911 8.78525 13.5013 9.15847 13.7775 9.47189C14.0536 9.7853 14.3892 10.0316 14.7617 10.1942L14.9144 10.2553L16.5741 10.8626C17.8048 11.3133 17.8421 13.1354 16.6866 13.6696L16.5741 13.7148L14.9144 14.323C14.5336 14.4622 14.1851 14.6874 13.8925 14.9833C13.5999 15.2791 13.3699 15.6388 13.218 16.0381L13.1611 16.2008L12.5942 17.98C12.1737 19.2987 10.4731 19.3386 9.97522 18.1005L9.93161 17.98L9.36477 16.2016C9.23479 15.7936 9.02464 15.4202 8.74851 15.1067C8.47238 14.7931 8.13669 14.5467 7.7641 14.384L7.61219 14.323L5.95245 13.7156C4.721 13.265 4.68373 11.4429 5.83992 10.9094L5.95245 10.8626L7.61219 10.2553C7.99283 10.1159 8.34115 9.89069 8.63365 9.59483C8.92616 9.29896 9.15604 8.93932 9.3078 8.54017L9.36477 8.37741L9.93161 6.59826ZM16.8892 4C17.0207 4 17.1497 4.03955 17.2613 4.11414C17.373 4.18874 17.4628 4.2954 17.5207 4.42199L17.5545 4.51016L17.8006 5.28331L18.5229 5.54705C18.6547 5.59505 18.7703 5.68391 18.855 5.80237C18.9397 5.92082 18.9896 6.06355 18.9985 6.21246C19.0074 6.36136 18.9748 6.50974 18.9049 6.63879C18.835 6.76784 18.731 6.87176 18.6059 6.93736L18.5229 6.97353L17.8013 7.23728L17.5552 8.01118C17.5103 8.15241 17.4273 8.2762 17.3167 8.36685C17.2061 8.4575 17.0729 8.51093 16.9339 8.52037C16.795 8.52981 16.6565 8.49484 16.5361 8.41989C16.4157 8.34494 16.3188 8.23338 16.2576 8.09934L16.2239 8.01118L15.9777 7.23803L15.2555 6.97428C15.1236 6.92629 15.008 6.83743 14.9233 6.71897C14.8387 6.60051 14.7887 6.45778 14.7798 6.30888C14.7709 6.15997 14.8035 6.01159 14.8734 5.88254C14.9433 5.75349 15.0474 5.64958 15.1725 5.58397L15.2555 5.5478L15.977 5.28406L16.2232 4.51016C16.2706 4.36127 16.3603 4.23203 16.4797 4.14054C16.5992 4.04905 16.7424 3.99991 16.8892 4Z"
      fill="currentColor"
    />
  </svg>
);
